import AbstractPage from 'page/AbstractPage';
import ProductListViewMode from 'component/ProductListViewMode';
import ProductFilter from 'component/ProductFilter';
import tools from 'tools';

export default class SearchPage extends AbstractPage {
    constructor() {
        super();
        this.initSpoilers();
        this.viewMode = new ProductListViewMode;
        this.$parent = $('.section-filter__container');
        this.$filterForm = $('.smartfilter');
        this.initFilter();
    }

    initFilter() {
        this.filter = new ProductFilter;
        const mql = window.matchMedia('(min-width: 768px)');

        const resizeCallback = (e) => {
            if ( window.matchMedia('(min-width: 768px)').matches ) {
                $('.product-filter').css('display', 'block');
            } else {
                $('.product-filter').css('display', 'none');
            }
        };

        try {
            mql.addEventListener('change', resizeCallback);
        } catch (ex) {
            try {
                mql.addListener(resizeCallback);
            } catch (ex) {}
        }

        if (mql.matches) {
            $('.product-filter').css('display', 'block');
        } else {
            $('.product-filter').css('display', 'none');
        }

        $('.catalog-filter-mobile-trigger').on('click', function () {
            $('.product-filter').slideToggle();
        });

        this.$parent.find('.section-filter__item').on('click', this.onSectionClick.bind(this));
    }

    onSectionClick(e) {
        e.preventDefault();
        const sectionId = e.currentTarget.getAttribute('data-id');

        if (this.$filterForm.find("input[name=\"section_id\"]").length == 0) {
            this.$filterForm.prepend('<input type="hidden" id="section_id" name="section_id"/>');
        }

        this.$filterForm.find("input[id=\"section_id\"]").val(sectionId);

        let dataForm = this.$filterForm.find(":input").filter(function () {
            return $.trim(this.value).length > 0
        }).serialize();

        let url = window.location.pathname + '?' + dataForm;
        window.location.href = url;
    }
    initSpoilers() {
        const itemsInRow = [
            {width: [1570, 10000], count: 4},
            {width: [992, 1569], count: 3},
            {width: [576, 991], count: 2},
            {width: [0, 575], count: 2},
        ];

        //вывод определенного количества товаров, функционал для кнопки показать ещё
        /*$('.product-list-wrapper').each((index, el) => {
            if ($(el).find('.product-list-item').length > 4) {
                $(el).attr('data-useSpoiler', 'true');
                $(el).find('.news-detail__spoiler-trigger').toggleClass('hidden', false);
            }
        });*/

        for (let condition of itemsInRow) {
            let mql = window.matchMedia(`(min-width: ${condition.width[0]}px) and (max-width: ${condition.width[1]}px)`);
            mql.addListener(this.updateSpoilers.bind(this, condition.count));

            if (mql.matches) {
                this.updateSpoilers(condition.count);
            }
        }

        $('.news-detail__spoiler-trigger-link').on('click', this.onSpoilerClick.bind(this));
    }

    updateSpoilers(visibleCount, e) {
        if (e && !e.matches) {
            return;
        }

        $('.product-list-wrapper').each((index, el) => {
            if (!$(el).attr('data-useSpoiler')) {
                return;
            }

            $(el).find(`.product-list-item:lt(${visibleCount})`).toggleClass('hidden', false);
            $(el).find(`.product-list-item:gt(${visibleCount - 1})`).toggleClass('hidden', true);

            const count = $(el).find(`.product-list-item.hidden`).length;
            $(el).find('.news-detail__spoiler-trigger-link [data-var="count"]').html(' ' + count + ' ' + tools.plural(count, 'товар', 'товара', 'товаров'));
        });
    }

    onSpoilerClick(e) {
        e.preventDefault();

        const $container = $(e.currentTarget).closest('.product-list-wrapper');
        $container.find('.product-list-item').toggleClass('hidden', false);
        $container.find('.news-detail__spoiler-trigger').toggleClass('hidden', true);
    }
}


$(function () { app.pageController = new SearchPage(); });
